module.exports = require('./src/modules/I18n/i18n');
